import Splide from "@splidejs/splide";
import "@splidejs/splide/css";

const CalendarCarousel = () => {
    const calendars = document.querySelectorAll( '.wp-block-query.is-calendar-slider' )

    if ( calendars.length === 0 ) return



    const options = {
        perPage: 3,
        perMove: 1,
        pagination: false,
        slidesPerView:'auto',
        spaceBetween: 20,
        breakpoints: {
            780: {
                perPage: 1
            }
        }
    }

  const setClasses = (calendar) => {
    calendar.parentNode.classList.add("splide");
    calendar.classList.add("splide__track");
    calendar.querySelector(".wp-block-post-template")?.classList.add("splide__list");
    calendar.querySelectorAll(".wp-block-post").forEach((post) => post.classList.add("splide__slide"));
  };

  const initSwiper = (calendar, idx) => {
    if (calendar.querySelector(".wp-block-query-no-results")) return;
    calendar.parentNode.id = `splide-calendar-${idx}`;
    setClasses(calendar);
    new Splide(`#splide-calendar-${idx}`, options).mount();
  };
  calendars.forEach(initSwiper);
};

export default CalendarCarousel;
